import { BitmapLayer, TileLayer } from 'deck.gl';

// Toponimos del basemap (comunas, barrios, calles principales) por encima de
// los hexagonos. El basemap vectorial va sin etiquetas y estas llegan como
// tiles raster de la misma familia (CartoDB dark, solo etiquetas), dibujadas
// como ultima capa de deck.gl. La alternativa era el modo interleaved, que
// mete las capas de deck dentro del stack de MapLibre; se descarto porque las
// ondas y los arcos dependen de mezcla aditiva y depthTest desactivado, y ese
// modo comparte el estado de GL con el basemap. Los tiles raster de CARTO
// exigen una API key (REACT_APP_CARTO_KEY, en app/.env.local); sin ella llegan
// con la marca "API KEY REQUIRED".
const URL_ETIQUETAS =
  'https://basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}@2x.png' +
  `?key=${process.env.REACT_APP_CARTO_KEY}`;

export function construyeCapaEtiquetas() {
  return new TileLayer({
    id: 'etiquetas',
    data: URL_ETIQUETAS,
    tileSize: 256,
    pickable: false,
    parameters: { depthTest: false },
    renderSubLayers: (props) => {
      const [[oeste, sur], [este, norte]] = props.tile.boundingBox;
      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [oeste, sur, este, norte],
        parameters: { depthTest: false },
      });
    },
  });
}
